import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {getRentalCarPrices} from "./frontend_script";

class SearchResultInterstatePage extends Component {
	constructor(props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.onChangeVehicleGroup = this.onChangeVehicleGroup.bind(this);
		this.state = {
			selected_vehicle: '',
			selected_vehicle_name: '',
			category_group_filter: this.props.category_group_filter
		}
	}

	componentDidUpdate() {
		if (this.props.scroll_to_element === 'id_vehicles_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value(),
//				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
	}

	callbackRentalCarPrices(resp, t) {
		let to_show = t.props.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price;
		to_show.span_towing_surcharge = prices.towing_surcharge_price;
		if (prices.allowance > 0)
			to_show.kms = prices.allowance;
		t.props.handleSetShowData(to_show);
	}


	onSelect(id, name, vehicle_payment) {
		this.props.handleSetSomeBlock('scroll_to_element', 'id_extras_page');

		this.setState({selected_vehicle: id, selected_vehicle_name: name});

		this.props.handleSetHireIncludes(id, name, '', '', '', vehicle_payment);

		getRentalCarPrices(this.props.booking_form_data.booking, this.callbackRentalCarPrices, this);
	}

	onChangeVehicleGroup(e) {

		let vehicles_filtered = [];

		let category = parseInt(e.target.value);
		this.setState({category_group_filter: category});
		this.props.handleSetSomeBlock('category_group_filter', category);

		if (category > 0) {
			let bf_category_categories = window.bf_category_categories;
			if (Object.keys(bf_category_categories) && Object.keys(bf_category_categories).length > 0 && category && bf_category_categories[category] && Object.keys(bf_category_categories[category]) && Object.keys(bf_category_categories[category]).length > 0) {
				if (Object.keys(this.props.search_result.vehicles).length > 0) {
					let i = 0;
					Object.keys(this.props.search_result.vehicles).map((k) => {
						if (bf_category_categories[category].includes(this.props.search_result.vehicles[k].vehiclecategoryid)) {
							vehicles_filtered[i] = this.props.search_result.vehicles[k];
							i++;
						}
					});
				}
			}
		}
		else if (category === 0) {
			vehicles_filtered = this.props.search_result.vehicles;
		}

		let search_result_filter = {
			'vehicles': ( vehicles_filtered && Object.keys(vehicles_filtered) && Object.keys(vehicles_filtered).length) ? vehicles_filtered : {},
			'vehicles_closest_date': {},
			'vehicles_closest': {}
		};

		this.props.handleSetFilterResultInterstate(true, false, search_result_filter, category);
	}

	render() {
		let category_groups = window.bf_category_groups;
		let vehicles = this.props.search_result_filter.vehicles;

		return (<>
			<RedirectOnlyHome />

			<div id={'id_vehicles_div'} className={'vehicles'} style={{marginBottom: "25px", marginTop:"30px"}}>
				<div className="row">
					{
						(this.props.search_result.success && vehicles && Object.keys(vehicles) && Object.keys(vehicles).length > 0) ?
							(
								<div className="col">
									<div className="row">
										<div className="col-md-7">
											<h2 style={{textAlign:'left'}}>Your Available Vehicles</h2>
										</div>
										<div className="col-md-5">
											<div className="row match_vehicles_filter">
												<div class={'col-md-5'} style={{textAlign:'right'}}>
													<label className="filter-vehicle" style={{paddingTop: "5px",paddingBottom: "5px"}}>Filter results by:</label>
												</div>
												<div class={'col-md-7'}>
													<select className="form-control filter-vehicle"
														name="category_group_filter"
														onChange={this.onChangeVehicleGroup}
														value={this.state.category_group_filter}>
														<option value="0" key="0"></option>
														{Object.keys(category_groups).map((keyName) => (
															<option value={category_groups[keyName]} key={category_groups[keyName]}>{keyName}</option>
														))}
													</select>
												</div>
											</div>
										</div>
									</div>

									<div className="row match_vehicles" style={{marginBottom:"15px", textAlign:"left"}}>
									{
										vehicles.map((v) => {
											const truck_picture = {
												backgroundImage:`url(${v.picture})`,
												zIndex: '100'
											};

												return (
													<div className="vehicle col-md-6" id={v.id} style={{marginBottom: "15px"}} key={v.id}>
														<div className="row" style={{backgroundColor: "#f0f0f0",marginLeft: "0px",marginRight: "0px", borderRadius:"48px"}}>
															<div className="offset-md-3 col-md-6 truck-picture" style={truck_picture}></div><div className="col-md-6"></div>
															<div className="col-md-12">
																<h3  style={{textAlign:'center'}}>{v.name}</h3>
																<p className="description">{v.description}</p>
																<p>
																	{
																		v.volume &&
																		<span className="volume"><i className="fas fa-box-open"></i>{v.volume}</span>
																	}
																	<span className="passengers"><i className="fas fa-user"></i>{v.passengers}</span>
																</p>
																<p className="description additional-info">{v.additional_descr}</p>
																<div className={'bottomRow'}>
																	<span>
																		{
																			!!v.price && false ? ( <span><span className="price">{v.price}</span>Per Day</span>) : null
																		}
																	</span>
																	<input type="button"
																		   className={'btn btn-large btn-green-border'+ ((v.id === this.props.booking_form_data.booking.vehicle) ? ' active' : '')}
																		   value="Select"
																		   onClick={()=>{this.onSelect(v.id, v.name, v.vehicle_payment)}}
																	/>
																</div>
															</div>
														</div>
													</div>
												)
											}
										)
									}
									</div>
							</div>
							) :
							(
								<div className="col text-center">
									<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
										 alt="gecko headset"
										 className="alignleft" />
									<p style={{color: "#d63545", fontSize: "18px"}}><strong>No Vehicles Available</strong></p>
									<p>
										Filter results by :  <select className="form-control"
																	 name="category_group_filter"
																	 onChange={this.onChangeVehicleGroup}
																	 value={this.state.category_group_filter}
																	 style={{width: "unset", display: "unset"}}>
										<option value="0" key="0"></option>
										{Object.keys(category_groups).map((keyName) => (
											<option value={category_groups[keyName]} key={category_groups[keyName]}>{keyName}</option>
										))}
									</select>
									</p>
									<p>Our system currently isn't showing any available vehicles at that location during this time period. Please contact Go With The Gecko on <a href="tel:1300 826 883">1300 826 883</a> and we will be able to help identify a quick easy solution to your booking needs.</p>
									<p><a href="tel:1300826883" className="btn btn-green">Call 1300 826 883</a></p>
								</div>
							)
					}
				</div>
			</div>
		</>);
	}
}

export default SearchResultInterstatePage;
